export const projects = [
  {
    title: "Drone-Website",
    subtitle: "Reactjs, Javascript, Html, Css, Bootstrap, Emailjs",
    description:
      "Hawaiadda is a dynamic and interactive website showcasing the capabilities of drones. It is currently hosted on Netlify.",
    image: "./Hawaiadda.gif",
    link: "https://dronewebsite.netlify.app/",
  },
  {
    title: "Typing Test Game",
    subtitle: "Reactjs, Random quote api, Javascript, Html, Css",
    description:
      "The typing test game is a project that lets users test their typing speed and accuracy by typing out a random passage of text. The source code for this project is available on GitHub.",
    image: "./typing test game.gif",
    link: "https://github.com/prakharpratap97/typing-test",
  },
  {
    title: "Sticky Notes",
    subtitle: "Html, Css, Javascript, React, React-dragabble",
    description:
      "A web-based application for creating and organizing notes. This project allows users to efficiently manage their to-do lists and important reminders. The source code for this project is available on GitHub.",
    image: "./stickynotes.gif",
    link: "https://github.com/prakharpratap97/stickynotes-using-reactjs-html-and-css",
  },

  {
    title: "Calce - A Calculator",
    subtitle: "Html, Css, Javascript",
    description:
      "Calce is a user-friendly, feature-rich calculator website built using HTML, CSS, and Javascript. It is currently hosted on 000Webhost",
    image: "./Calce.png",
    link: "https://unpuckered-companie.000webhostapp.com/",
  },
];

// export const skills = [
//   "Html",
//   "Css",
//   "JavaScript",
//   "React",
//   "Bootstrap",
//   "Python",
//   "MySql",
//   "Cloud",

// ];

export const skills = [
  {
    title: "Html",
    link: "https://www.coursera.org/account/accomplishments/certificate/ZE84FPH3GT2J",
  },
  {
    title: "Css",
    link: "https://www.sololearn.com/certificates/CT-4EFHZLOO",
  },
  {
    title: "JavaScript",
    link: "https://www.coursera.org/account/accomplishments/verify/PPPE5DK4L8EZ",
  },
  {
    title: "React",
    link: "https://www.udemy.com/certificate/UC-1a8b61ec-9713-47f1-8f49-dc9196b1ca8c/",
  },
  {
    title: "Bootstrap",
    link: "https://getbootstrap.com/",
  },
  {
    title: "Python",
    link: "https://olympus1.greatlearning.in/course_certificate/LZTLCMOO",
  },
  {
    title: "MySql",
    link: "https://www.sololearn.com/certificates/CT-YSVZQJK6",
  },
  {
    title: "Cloud",
    link: "https://www.udemy.com/certificate/UC-b0628d11-f138-4311-a763-f88ba7d23918/",
  },
  {
    title: "Responsive Web Design",
    link: "https://www.sololearn.com/certificates/CT-LI9ZHHSF",
  },
  {
    title: "Git",
    link: "https://www.linkedin.com/learning/certificates/189d7ff9ca03fc255806b60587c5db5c16292f3f48f56c901091b22cf79abaf2",
  },
];



// WEBPACK FOOTER //
// ./src/data.js